import type { JsFile } from '../../../types'
import type { TagRegistry } from '../../../tagRegistry'
import { ElementDefinitionBuilder } from '../../../elementDefinition'
import { INNER_ELEMENT_TAG, INNER_ELEMENT_TYPE } from './constants'

interface ElementEntry {
    tag: string
    componentType: string
}

const withWrappers = (output: string): string => {
    return `customElements = window.customElements || {};\n${output}`
}

export const generateElements = (registry: TagRegistry): JsFile => {
    const entries: ElementEntry[] = Array.from(registry.typeToTagEntries, ([componentType, tag]) => ({
        tag,
        componentType,
    }))

    if (entries.length === 0) {
        return { type: 'js', content: '' }
    }

    const hasInnerElement = entries.some(entry => entry.tag === INNER_ELEMENT_TAG)
    if (!hasInnerElement) {
        entries.push({ tag: INNER_ELEMENT_TAG, componentType: INNER_ELEMENT_TYPE })
    }

    entries.sort((a, b) => a.tag.localeCompare(b.tag))

    const builder = new ElementDefinitionBuilder()
    for (const { tag, componentType } of entries) {
        builder.addElement(tag, { componentType })
    }

    return { type: 'js', content: withWrappers(builder.build()) }
}
